module.exports = __webpack_public_path__ + "img/JobApplication.bab2b6a7.svg";